/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import ProductsForm from '../components/form';
import { ADD_PRODUCT } from '../../../../queries/products/product';

export const AddProducts = (props) => {
  return (
    <Mutation
      mutation={ADD_PRODUCT}
      update={async () => {
        await props.refetch();
      }}
    >

      {createTitle => (
        <ProductsForm query_f={createTitle} {...props} />
      )}
    </Mutation>
  );
};
